// Node Libraries
import React, { memo, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import {
	Dialog,
	DialogButtons,
	DialogContent,
	DialogPane,
	PrimaryButton,
	SecondaryButton,
	Icon,
	Thumbnail,
} from 'swp-react';
// Styling
import invalidFilesModalStyle from './InvalidFilesModal.module.scss';
import FormattedMessage from '@/components/FormattedMessage';
import { selectHostName } from '@/slices/commonSlice';
import { useSelector } from 'react-redux';

export const InvalidFilesModal = (props) => {
	const { handleCloseModal, open, unsupportedFiles, failedImages } = props;

	const hostName = useSelector(selectHostName);

	const [showDetails, setShowDetails] = useState(false);
	const [showDetailsFailed, setShowDetailsFailed] = useState(false);
	const [unsupported, setUnsupported] = useState([]);
	const [failed, setFailed] = useState([]);

	// create objectUrls for unsupported files and failed images
	useEffect(() => {
		if (unsupportedFiles?.length > 0) {
			const newUnsupported = unsupportedFiles.map((file) => {
				if (file && file instanceof Blob) {
					try {
						return {
							name: file?.name,
							objectUrl: URL.createObjectURL(file),
						};
					} catch (error) {
						return {};
					}
				}
				return {};
			});
			setUnsupported(newUnsupported);
		}
		if (failedImages?.length > 0) {
			const newFailed = failedImages.map((file) => {
				if (file && file instanceof Blob) {
					try {
						return {
							name: file?.name,
							objectUrl: URL.createObjectURL(file),
						};
					} catch (error) {
						return {};
					}
				}
				return {};
			});
			setFailed(newFailed);
		}

		return () => {
			if (unsupported?.length > 0) {
				unsupported.forEach((file) => {
					if (file?.objectUrl) {
						URL.revokeObjectURL(file?.objectUrl);
					}
				});
			}
			if (failed?.length > 0) {
				failed.forEach((file) => {
					if (file?.objectUrl) {
						URL.revokeObjectURL(file?.objectUrl);
					}
				});
			}
		};
	}, [unsupportedFiles, failedImages]);

	// #region Render UI
	return (
		/* */
		<Dialog
			open={open}
			closeHandler={handleCloseModal}
			preventEscapeClose={false}
			preventBackdropClose={false}
			minWidth="300px"
			maxWidth="100%"
			modalMaxWidth="100%"
			className={invalidFilesModalStyle['invalid-files-modal-wrapper']}
		>
			<DialogPane
				sx={{ textAlign: 'center' }}
				className="invalid-files-modal-pane"
				style={{
					backgroundColor: '#FFFFFF',
					width: '100%',
					'--button-border-radius':
						hostName === 'ng' ? '100px' : 'unset',
				}}
			>
				<DialogContent className="invalid-files-modal-content">
					<header>
						<h1 className="heading-02">
							<FormattedMessage id="invalid-upload-type-dialog-title" />
						</h1>
					</header>
					<div className="body-container">
						<div className="body-wrapper">
							<FormattedMessage id="upload-failed" />
						</div>
						<PrimaryButton
							className="see-file-details"
							onClick={() => setShowDetails(!showDetails)}
						>
							<FormattedMessage id="see-details" />
							<Icon
								name={
									showDetails
										? 'IconChevronUp'
										: 'IconChevronDown'
								}
								className="details-icon"
							/>
						</PrimaryButton>
						{showDetails && (
							<div className="invalid-file-names">
								{failed?.length > 0 && (
									<div className="body-wrapper">
										<FormattedMessage id="photo-failed" />
										<div className="invalid-files">
											{failed.map((file, index) => (
												<div
													key={`invalid-file-${index}`}
													className="invalid-file-name"
													style={{}}
												>
													{file?.isCorrupt ? (
														<div className="corrupt-file-overlay">
															<Icon
																name="IconNoPhoto"
																className="warning-icon"
															/>
														</div>
													) : (
														<Thumbnail
															alt={file?.name}
															cropStyle={'full'}
															// id={id}
															isSelected={false}
															onClick={() => {}}
															onError={(e) => {
																setFailed(
																	(
																		prevFiles
																	) =>
																		prevFiles.map(
																			(
																				prevFile,
																				i
																			) => {
																				if (
																					i ===
																					index
																				) {
																					return {
																						...prevFile,
																						isCorrupt: true,
																					};
																				}
																				return prevFile;
																			}
																		)
																);
															}}
															onLoad={() => {}}
															// preloadSrc={
															// 	file?.objectUrl
															// }
															selectStyle={
																'checkmark'
															}
															showLoadingBar={
																false
															}
															showSkeleton={true}
															showSpinner={false}
															size={'100%'}
															src={
																file?.objectUrl
															}
														/>
													)}
													<div className="file-name">
														{file?.name}
													</div>
												</div>
											))}
										</div>{' '}
									</div>
								)}
								{unsupported?.length > 0 && (
									<div className="body-wrapper">
										<FormattedMessage id="invalid-upload-type-dialog-body" />
										<div className="invalid-files">
											{unsupported.map((file, index) => (
												<div
													key={`invalid-file-${index}`}
													className="invalid-file-name"
													style={{}}
												>
													{file?.isCorrupt ? (
														<div className="corrupt-file-overlay">
															<Icon
																name="IconNoPhoto"
																className="warning-icon"
															/>
														</div>
													) : (
														<Thumbnail
															alt={file?.name}
															cropStyle={'full'}
															// id={id}
															isSelected={false}
															onClick={() => {}}
															onError={(e) => {
																setUnsupported(
																	(
																		prevFiles
																	) =>
																		prevFiles.map(
																			(
																				prevFile,
																				i
																			) => {
																				if (
																					i ===
																					index
																				) {
																					return {
																						...prevFile,
																						isCorrupt: true,
																					};
																				}
																				return prevFile;
																			}
																		)
																);
															}}
															onLoad={() => {}}
															// preloadSrc={
															// 	file?.objectUrl
															// }
															selectStyle={
																'checkmark'
															}
															showLoadingBar={
																false
															}
															showSkeleton={true}
															showSpinner={false}
															size={'100%'}
															src={
																file?.objectUrl
															}
														/>
													)}
													<div className="file-name">
														{file?.name}
													</div>
												</div>
											))}
										</div>{' '}
									</div>
								)}
							</div>
						)}
					</div>
				</DialogContent>
				<DialogButtons className="buttons-container">
					<PrimaryButton
						type="submit"
						id="invalid-files-ok-button"
						name="button-invalid-files-ok"
						size="fullwidth"
						onClick={() => {
							handleCloseModal?.();
						}}
					>
						<FormattedMessage id="btn-ok" />
					</PrimaryButton>
				</DialogButtons>
			</DialogPane>
		</Dialog>
		/* */
	);
};
// #endregion

InvalidFilesModal.displayName = 'InvalidFilesModal';
export default InvalidFilesModal;
